import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { CookiesService } from './cookies.service';
import { MakersiteService } from './makersite.service';
import { GlobalDataService } from '@services/global-data.service';
import { LocalStorageService } from '@services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class SessionTimeoutService {
  constructor(
    private router: Router,
    private cookiesService: CookiesService,
    private globalDataService: GlobalDataService,
    private localStorageService: LocalStorageService,
    private makersiteService: MakersiteService
  ) {}

  timeoutInterval = 1800000; // holds the idle duration in ms (current value = 1 minute)
  timeHook = null; // holds the timeout variables for easy destruction and reconstruction of the setTimeout hooks

  initializeSession() {
    this.destroyTimeHook(); // to prevent any lingering timeout handlers preventing memory leaks
    this.initializeTimeHook(); // setup a fresh time hook
    this.setupListeners(); // setup initial event listeners
  }

  logout() {
    this.makersiteService.logout().subscribe(() => {
      this.localStorageService.clear();
      this.cookiesService.clearCookies();
      this.globalDataService.setPpmSelectedItem(null);
      this.globalDataService.setTokenString(null);
      this.globalDataService.setPPMLayer(null);
      this.globalDataService.setPpmId(null);
      this.router.navigate(['login']);
    });
  }

  initializeTimeHook() {
    // this method has the purpose of creating our timehooks and scheduling the call to our logout function when the idle time has been reached
    if (this.timeHook === null) {
      this.timeHook = setTimeout(() => {
        this.destroyTimeHook();
        this.logout();
      }, this.timeoutInterval);
    }
  }

  setupListeners() {
    // here we setup the event listener for the mouse click operation
    document.addEventListener('click', () => this.resetTimeHook());
  }

  destroyTimeHook() {
    // this method has the sole purpose of destroying any time hooks we might have created
    clearTimeout(this.timeHook);
    this.timeHook = null;
  }

  resetTimeHook() {
    // this method replaces the current time hook with a new time hook
    this.destroyTimeHook();
    this.initializeTimeHook();
  }

  destroyListeners() {
    // here we destroy event listeners for the mouse click operation
    document.removeEventListener('click', () => this.resetTimeHook());
  }
}
